export async function sleep(second: number) {
  await new Promise((resolve) => {
    setTimeout(resolve, second * 1000);
  });
}
